export default __webpack_public_path__ + "static/media/team2-1.54856dcd.jpg";